import { Builder } from '@builder.io/react'
import React from 'react'

interface Props {
  backgroundColor: string
  title: string
  additive: { name: string; value: string }[]
}

const RecipeAdditivesLister = ({ backgroundColor, title, additive }: Props) => {
  const getAnalytical = () => {
    if (!additive) return

    return additive.map((additiveItem, i: number) => {
      return (
        <div
          className="p-2 text-center mr-2 mb-2 break-words w-[6.5rem] rounded-md bg-[#dce9d0] font-medium text-black"
          key={`${additiveItem.name}-${i}`}
        >
          <p className="pb-1 text-xs sm:text-sm">{additiveItem.name}</p>
          <div className="recipe-divider" />
          <p className="pt-1 text-xs sm:text-sm">{additiveItem.value}</p>
        </div>
      )
    })
  }

  return (
    <div className="w-full p-2" style={{ backgroundColor: backgroundColor }}>
      <div className="px-4 mx-auto">
        <h3 className="mb-4 font-sans font-semibold text-base lg:text-2xl text-[#004355]">{title}</h3>
        <div className="mb-8 flex flex-wrap">{getAnalytical()}</div>
      </div>
    </div>
  )
}

export default RecipeAdditivesLister

Builder.registerComponent(RecipeAdditivesLister, {
  name: 'recipeAdditivesLister',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },

    {
      name: 'title',
      type: 'string',
      defaultValue: 'Title'
    },

    {
      name: 'additive',
      type: 'list',
      subFields: [
        { name: 'name', type: 'text', defaultValue: 'Protein' },
        { name: 'value', type: 'text', defaultValue: '4.5mg' }
      ],
      defaultValue: []
    }
  ]
})
